import { useState, useEffect } from 'react';
import _ from 'lodash'; // Import lodash's isEqual for deep comparison

const useTrackedState = (data, comparisonFn = _.isEqual) => {
  const [state, setState] = useState(data);

  useEffect(() => {
    setState(prevState => {
      if (!comparisonFn(prevState, data)) {
        return data;
      }
      return prevState;
    });
  }, [data, comparisonFn]);

  return state;
};

export default useTrackedState;